import { Alert, Box, Button, Card, CardContent, Divider, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";

import { ApiError } from "../api/client";
import { useAuth } from "./AuthContext";

export function LoginPage() {
  const { providers, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [blad, setBlad] = useState<string | null>(null);
  const [wysylanie, setWysylanie] = useState(false);

  const haslem = providers.some((p) => p.interactive);
  const przezM365 = providers.some((p) => p.source === "entra");

  async function wyslij(e: React.FormEvent) {
    e.preventDefault();
    setBlad(null);
    setWysylanie(true);
    try {
      await login(username, password);
    } catch (e) {
      // Serwer celowo nie rozróżnia „nie ma konta" od „złe hasło" —
      // panel nie ma czego dopowiadać.
      setBlad(e instanceof ApiError ? e.message : "Nie udało się zalogować.");
    } finally {
      setWysylanie(false);
    }
  }

  return (
    <Box sx={{ display: "grid", placeItems: "center", minHeight: "100vh", bgcolor: "background.default" }}>
      <Card sx={{ width: 400 }} elevation={3}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Kosztorysy produkcji
          </Typography>

          {haslem && (
            <form onSubmit={wyslij}>
              <Stack spacing={2} sx={{ mt: 1 }}>
                {blad && <Alert severity="error">{blad}</Alert>}
                <TextField
                  label="Login" value={username} autoFocus autoComplete="username"
                  onChange={(e) => setUsername(e.target.value)} size="small" fullWidth
                />
                <TextField
                  label="Hasło" type="password" value={password} autoComplete="current-password"
                  onChange={(e) => setPassword(e.target.value)} size="small" fullWidth
                />
                <Button type="submit" variant="contained" disabled={wysylanie}>
                  {wysylanie ? "Logowanie…" : "Zaloguj"}
                </Button>
              </Stack>
            </form>
          )}

          {przezM365 && (
            <>
              {haslem && <Divider sx={{ my: 2 }}>albo</Divider>}
              <Button fullWidth variant="outlined" href="/api/auth/entra/start">
                Zaloguj przez Microsoft 365
              </Button>
            </>
          )}

          {providers.length === 0 && (
            <Alert severity="warning">
              Nie skonfigurowano żadnego sposobu logowania.
            </Alert>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
